import {
  Anchor,
  Box,
  Burger,
  Drawer,
  Group,
  Image,
  ScrollArea,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/full-white-logo.webp';
import './PublicHeader.css';

const PublicHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] =
    useDisclosure(false);

  const handleFeaturesClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    closeDrawer();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const featuresSection = document.getElementById('features');
        if (featuresSection) {
          featuresSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }, 100);
    } else {
      const featuresSection = document.getElementById('features');
      if (featuresSection) {
        featuresSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const handlePricingClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    closeDrawer();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const pricingSection = document.getElementById('pricing');
        if (pricingSection) {
          pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const handleResourcesClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    closeDrawer();
    navigate('/resources');
  };

  const handleAboutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    closeDrawer();
    navigate('/about');
  };

  return (
    <Box component='header' className='public-header'>
      <Group
        justify='space-between'
        h='100%'
        px={{ base: 'md', md: 'xl' }}
        style={{ width: '100%' }}
      >
        {/* Logo on the left */}
        <Image
          src={logo}
          alt='Practist Logo'
          h={{ base: '2.5rem', md: '3rem' }}
          w='auto'
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/')}
        />

        {/* Menu items in the center */}
        <Group
          h='100%'
          gap={0}
          visibleFrom='sm'
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          <Anchor
            href='#'
            onClick={handleFeaturesClick}
            c='white'
            fz='md'
            style={{ textDecoration: 'none', padding: '0 1rem' }}
            className='header-link'
          >
            Features
          </Anchor>
          <Anchor
            href='#'
            onClick={handlePricingClick}
            c='white'
            fz='md'
            style={{ textDecoration: 'none', padding: '0 1rem' }}
            className='header-link'
          >
            Pricing
          </Anchor>
          <Anchor
            href='/about'
            onClick={handleAboutClick}
            c='white'
            fz='md'
            style={{ textDecoration: 'none', padding: '0 1rem' }}
            className='header-link'
          >
            About Us
          </Anchor>
          <Anchor
            href='/resources'
            onClick={handleResourcesClick}
            c='white'
            fz='md'
            style={{ textDecoration: 'none', padding: '0 1rem' }}
            className='header-link'
          >
            Resources
          </Anchor>
        </Group>

        {/* Existing customer access */}
        <Group visibleFrom='sm' gap='md'>
          <Anchor
            href='https://firms.practist.io/login'
            c='white'
            fz='md'
            style={{ textDecoration: 'none' }}
          >
            Sign In
          </Anchor>
        </Group>

        {/* Burger menu for mobile */}
        <Burger
          opened={drawerOpened}
          onClick={toggleDrawer}
          hiddenFrom='sm'
          color='white'
        />
      </Group>

      {/* Mobile drawer */}
      <Drawer
        opened={drawerOpened}
        onClose={closeDrawer}
        size='100%'
        padding='md'
        title='Navigation'
        hiddenFrom='sm'
        zIndex={1000000}
      >
        <ScrollArea h='calc(100vh - 80px)' mx='-md'>
          <Box px='md'>
            <Anchor
              href='#'
              onClick={handleFeaturesClick}
              c='var(--mantine-color-text)'
              style={{
                textDecoration: 'none',
                display: 'block',
                padding: '0.75rem 0',
              }}
            >
              Features
            </Anchor>
            <Anchor
              href='#'
              onClick={handlePricingClick}
              c='var(--mantine-color-text)'
              style={{
                textDecoration: 'none',
                display: 'block',
                padding: '0.75rem 0',
              }}
            >
              Pricing
            </Anchor>
            <Anchor
              href='/about'
              onClick={handleAboutClick}
              c='var(--mantine-color-text)'
              style={{
                textDecoration: 'none',
                display: 'block',
                padding: '0.75rem 0',
              }}
            >
              About Us
            </Anchor>
            <Anchor
              href='/resources'
              onClick={handleResourcesClick}
              c='var(--mantine-color-text)'
              style={{
                textDecoration: 'none',
                display: 'block',
                padding: '0.75rem 0',
              }}
            >
              Resources
            </Anchor>
          </Box>
          <Box px='md' mt='xl'>
            <Group justify='center' pb='xl'>
              <Anchor
                href='https://firms.practist.io/login'
                c='var(--mantine-color-text)'
                style={{ textDecoration: 'none' }}
              >
                Sign In
              </Anchor>
            </Group>
          </Box>
        </ScrollArea>
      </Drawer>
    </Box>
  );
};

export default PublicHeader;
